import MessengerHub from "./MessengerHub";
import IframeCurrier from "./IframeCurrier";

declare global {
  interface Window {
    SatProfSMS: MessengerHub;
  }
}

const messengerHub = new MessengerHub();

// bind to the window
window.SatProfSMS = messengerHub;

messengerHub.registerCurrier(new IframeCurrier());

export default messengerHub;

export { messengerHub as defaultMessengerHub };
